// ============================================================
// caseStatus.ts — a case's DERIVED status (there's no status column):
//   closed = has a close date (wins — a closed case is no longer Open). A close
//            date of only spaces is NOT one (matches the backend isCaseClosed).
//   open   = setup finalised, no close date
//   draft  = setup not finalised yet
// ONE rule, used by the case list's status filter AND the dashboard's
// "Open cases" tile, so the tile's number == the rows it opens.
// ============================================================
export type CaseStatusKey = 'draft' | 'open' | 'closed'
export const caseStatusKey = (c: { closeDate: string | null; setupFinalised: boolean }): CaseStatusKey => {
  if (c.closeDate && c.closeDate.trim() !== '') return 'closed'
  if (c.setupFinalised) return 'open'
  return 'draft'
}
